<app-base-modal
  title="Verificar APIs"
  [open]="open()"
  [showPrimary]="false"
  secondaryText="Cerrar"
  (onCancel)="close()"
>
  <div class="verificar-api">
    <div class="verificar-api__row">
      <div class="verificar-api__info">
        <p class="verificar-api__name">
          Sinergial
          <span class="verificar-api__badge">{{ versionSinergial }}</span>
        </p>
        <span class="verificar-api__url">{{ urlSinergial }}</span>
      </div>
      <div
        class="verificar-api__indicator"
        role="status"
        [attr.aria-label]="'Sinergial: ' + stateLabel(stateSinergial())"
        [class.verificar-api__indicator--normal]="stateSinergial() === ''"
        [class.verificar-api__indicator--loader]="stateSinergial() === 'LOAD'"
        [class.verificar-api__indicator--ok]="stateSinergial() === 'OK'"
        [class.verificar-api__indicator--error]="stateSinergial() === 'ERROR'"
      ></div>
    </div>

    <div class="verificar-api__row">
      <div class="verificar-api__info">
        <p class="verificar-api__name">GPO</p>
        <span class="verificar-api__url">{{ urlGpo }}</span>
      </div>
      <div
        class="verificar-api__indicator"
        role="status"
        [attr.aria-label]="'GPO: ' + stateLabel(stateGpo())"
        [class.verificar-api__indicator--normal]="stateGpo() === ''"
        [class.verificar-api__indicator--loader]="stateGpo() === 'LOAD'"
        [class.verificar-api__indicator--ok]="stateGpo() === 'OK'"
        [class.verificar-api__indicator--error]="stateGpo() === 'ERROR'"
      ></div>
    </div>

    @if (urlIntegra) {
      <div class="verificar-api__row">
        <div class="verificar-api__info">
          <p class="verificar-api__name">
            Integra
            <span class="verificar-api__badge">{{ versionIntegra }}</span>
          </p>
          <span class="verificar-api__url">{{ urlIntegra }}</span>
        </div>
        <div
          class="verificar-api__indicator"
          role="status"
          [attr.aria-label]="'Integra: ' + stateLabel(stateIntegra())"
          [class.verificar-api__indicator--normal]="stateIntegra() === ''"
          [class.verificar-api__indicator--loader]="stateIntegra() === 'LOAD'"
          [class.verificar-api__indicator--ok]="stateIntegra() === 'OK'"
          [class.verificar-api__indicator--error]="stateIntegra() === 'ERROR'"
        ></div>
      </div>
    }

    @if (urlPagos) {
      <div class="verificar-api__row">
        <div class="verificar-api__info">
          <p class="verificar-api__name">Pagos</p>
          <span class="verificar-api__url">{{ urlPagos }}</span>
        </div>
        <div
          class="verificar-api__indicator"
          role="status"
          [attr.aria-label]="'Pagos: ' + stateLabel(statePagos())"
          [class.verificar-api__indicator--normal]="statePagos() === ''"
          [class.verificar-api__indicator--loader]="statePagos() === 'LOAD'"
          [class.verificar-api__indicator--ok]="statePagos() === 'OK'"
          [class.verificar-api__indicator--error]="statePagos() === 'ERROR'"
        ></div>
      </div>
    }
  </div>
</app-base-modal>
